export const getEmptyStudent = () => {
  let student = {
    Avatar: "",
    Name: "",
    Guid: "",
  };

  return student;
};
